<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<el-col :span="6">
					<!-- 품명 / 품번 -->
					<search-input
						:label="getMessage_('QWCC000957') + ' / ' + getMessage_('QWCC000956')"
						paramKey="partNo"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="findPopupSearchParams.partNo"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPartPopup"></i></template>
					</search-input>
				</el-col>
				<!-- 협력사 -->
				<el-col :span="6">
					<search-input
						:label="getMessage_('QWCC000958')"
						paramKey="cofNm"
						@commInput="setSearchParam"
						:clearable="false"
						:propData="findPopupSearchParams.cofNm"
						:readonly="isPqyGuest"
						:iconReadonly="isPqyGuest"
					>
						<template v-slot:icon> <i class="icon-sf-search search-icon" @click="onPqyCpnyPopup"></i></template>
					</search-input>
				</el-col>
				<el-col :span="8">
					<div class="sf-input-group-wrapper">
						<span class="sf-input-group-wrapper__label">{{ getMessage_('QWCC001085') }}</span>
						<el-date-picker
							v-model="searchDateRange"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
						/>
					</div>
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="searchList" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
		<!-- 팝업추가 영역 -->
		<part-mng-popup ref="partMngPopup" @SendData="sendData" :scrId="scrId"></part-mng-popup>
		<comp-popup ref="compPopup" @SendData="qpyCpnyData" :scrId="scrId"></comp-popup>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/Eo4mApcn/store/helpers';
import SearchInput from '@qms/Components/SearchInput';
import PartMngPopup from '@qms/comm/commpopup/PartMngPopup/PartMngPopup.vue';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
export default {
	props: { scrId: { type: String, default: '' } },
	data() {
		return { searchDateRange: [] };
	},
	components: { SearchInput, PartMngPopup, CompPopup },
	async created() {
		try {
			this.searchDateRange = [...this.getFindPopupSearchDates_];
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error?.message
			});
		}
	},
	watch: {
		searchDateRange(newValue) {
			if (newValue == null) {
				this.setFindPopupSearchParams_({ key: 'strDt', value: '' });
				this.setFindPopupSearchParams_({ key: 'endDt', value: '' });
			}
			if (newValue?.length == 2) {
				const strDt = this.$moment(this.searchDateRange[0]).format('YYYYMMDD');
				const endDt = this.$moment(this.searchDateRange[1]).format('YYYYMMDD');
				this.setFindPopupSearchParams_({ key: 'strDt', value: strDt });
				this.setFindPopupSearchParams_({ key: 'endDt', value: endDt });
			}
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setSearchParam(param) {
			if (param.key === 'cofNm') {
				this.setFindPopupSearchParams_({ key: 'cofCd', value: '' });
			}
			this.setFindPopupSearchParams_(param);
		},
		onPartPopup() {
			this.$refs.partMngPopup.open(this.findPopupSearchParams.partNm);
		},
		//협력사조회 팝업
		onPqyCpnyPopup() {
			let params = {
				cpnyScn: '10',
				cpnyCd: this.findPopupSearchParams.cofCd
			};
			this.$refs.compPopup.open(params);
		},
		async searchList() {
			try {
				this.$sf_toggleLoading(true);
				await this.getList_('Y');
			} catch (error) {
				this.$sf_toast({
					type: 'error',
					message: error?.message
				});
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		sendData(row) {
			this.setFindPopupSearchParams_({ key: 'partNo', value: row.partNo });
		},
		qpyCpnyData({ cpnyCd, cpnyNm }) {
			this.setFindPopupSearchParams_({ key: 'cofCd', value: cpnyCd });
			this.setFindPopupSearchParams_({ key: 'cofNm', value: cpnyNm });
		}
	},
	computed: { ...rootComputed, ...serviceComputed }
};
</script>

<style></style>
